import {
  debounce,
  isFunction,
  map,
  find,
  isEmpty,
  filter,
  each,
  omit,
  some,
  identity,
  findIndex,
} from 'lodash';

function CustomSelectController($scope, $element, $filter, $document, $window, $timeout, customSelectParse, Helper) {
  'ngInject';
  const vm = this;

  let _itemHeight;
  const _parserResult = customSelectParse.parse(vm.repeat);

  const _isTagging = $element[0].hasAttribute('tagging') || false;
  const _isMultiple = $element[0].hasAttribute('multiple') || _isTagging || false;
  const _hasHideSearch = $element[0].hasAttribute('hide-search') || false;

  const _container = $element[0].querySelector('.custom-select-container');
  const _dropdown = $element[0].querySelector('.cs-dropdown');
  const _input = $element[0].querySelector('.js-input');
  const _matchLabel = $element[0].querySelector('.js-match-value');

  const _taggingTokens = vm.taggingTokens ? vm.taggingTokens.split('|') : [];
  const _taggingTokensMap = {
    Space: ' ',
    Comma: ','
  };

  const KEY_CODE = {
    DELETE: 8,
    TAB: 9,
    ENTER: 13,
    ESC: 27,
    UP: 38,
    DOWN: 40
  };

  vm.stayOnSelect = _getBoolean(vm.stayOnSelect) || _isMultiple || false;
  vm.resetSearchTerm = _getBoolean(vm.resetSearchTerm) || _isMultiple || false;
  vm.options = vm.options || [];
  vm.placeholder = vm.placeholder || '';
  vm.dropdownPosition = vm.dropdownPosition || 'auto';
  vm.dropdownPosUp = !!(vm.dropdownPosition === 'up');
  vm.showDropdown = false;
  vm.showInput = false;
  vm.loading = false;
  vm.deleteActive = false;
  vm.tabActive = true;
  vm.removeable = _getBoolean(vm.removeable) || false;
  vm.onSearchMinChars = vm.onSearchMinChars || 2;
  vm.taggingTokens = vm.taggingTokens || [];

  vm.activate = activate;
  vm.deactivate = deactivate;
  vm.selectItem = selectItem;
  vm.removeItem = removeItem;
  vm.removeSelection = removeSelection;
  vm.isCustom = isCustom;
  vm.isNotSelected = isNotSelected;
  vm.activateDropdown = activateDropdown;

  vm.change = debounce(change, vm._debounceTime);

  Helper.ready(_handleReady);

  /**
   * Watch the changes in modelValue and get the viewValue
   */
  $scope.$watchCollection(function() {
    return vm.modelValue;
  }, _setViewValue);

  /**
   * @private
   */
  function _handleReady() {

    _checkHideSearchCond();
    _handleAsyncOptions();

    if (vm.isCustom()) {
      vm.search = vm.modelValue || '';
    } else {
      vm.search = '';
    }

  }

  /**
   * Handle the options which are loaded async and view value is aliased
   * when onSearch is used the watch is disabled
   *
   * @private
   */
  function _handleAsyncOptions() {

    if (_parserResult.isAliased && !angular.isFunction(vm.onSearch)) {
      $scope.$watch(function() {
        return vm.options;
      }, function() {
        _setViewValue(vm.modelValue);
        _checkHideSearchCond();
      });
    }

  }

  /**
   * Returns the boolean value of given val
   * Used since directive scope binded with '@' gives strings
   * 'undefined' and 'null' returns the same output
   *
   * @param {String|Boolean} val value to convert
   * @returns {Boolean|Object} coverted value
   *
   * @private
   */
  function _getBoolean(val) {
    return typeof (val) === 'string' ? val === 'true' : val;
  }

  /**
   * Set the value for hideSearch based on following rules
   * - Enforce the hideSearch tag value if provided.
   * - Hide search if list has less than 10 items and (tagging, onSearch, isCustom) not enabled.
   * - Show search input (default case)
   *
   * @private
   */
  function _checkHideSearchCond() {

    if (_hasHideSearch) {
      vm.hideSearch = _getBoolean(vm.hideSearch);
    } else if (vm.options.length < 10 && !_isTagging && !angular.isFunction(vm.onSearch) && !vm.custom) {
      vm.hideSearch = true;
    } else {
      vm.hideSearch = false;
    }

  }

  /**
   * Set the view value to be displayed in match value inside match container
   *
   * @param {String|Object} newVal new model value
   * @private
   */
  function _setViewValue(newVal) {

    if (isFunction(vm.setNgModel)) { vm.setNgModel(newVal); }

    if (_isMultiple) {
      vm.selected = map(newVal, _getViewValue);
    } else {
      vm.selected = _getViewValue(newVal);
    }

  }

  /**
   * Get the value for viewValue from modelValue
   *
   * @param {String|Object} val modelValue to be converted
   * @returns {String|Object} the converted viewValue
   * @private
   */
  function _getViewValue(val) {

    let modelValue;

    if (_parserResult.isAliased) {
      modelValue = find(vm.options, function(obj) {
        return _parseModelValue(obj) === val;
      });
    }

    return modelValue || val;

  }

  /**
   * Parse the modelValue based on expression user provided in repeat
   *
   * @param {String|Object} val value to be parsed
   * @returns {String|Object} parsed value
   * @private
   */
  function _parseModelValue(val) {

    const locals = {};
    let result;

    locals[_parserResult.itemName] = val;
    result = _parserResult.modelMapper($scope, locals);

    return result;

  }

  /**
   * Handle enter, up and down key arrow events
   *
   * @param {Object} e keydown event
   * @private
   */
  function _keyHandler(e) {

    let list = $filter('filter')(vm.options, vm.search); // TODO: insert some logic to handle filter from outside

    if (_isMultiple) {
      list = $filter('filter')(list, vm.isNotSelected);
    }

    const min = _isTagging ? -1 : 0;
    const max = list.length - 1;

    if (e.shiftKey && e.keyCode === KEY_CODE.TAB) { // reverse tab

      vm.deactivate();
      $scope.$apply();

      return;

    }

    if (e.keyCode === KEY_CODE.ESC) {

      vm.deactivate();
      $scope.$apply();

      return;

    }

    if (e.keyCode === KEY_CODE.TAB) {

      if ((vm.search.length > 0 && _isTagging) || (vm.tabActive && vm.showDropdown && !_isTagging)) {

        e.preventDefault();
        vm.tabActive = false;

        if (_isTagging && (isEmpty(list) || vm.focus < 0)) {
          vm.selectItem(vm.search);
        } else {
          vm.selectItem(list[vm.focus]);
        }

      } else {
        vm.deactivate();
      }

      $scope.$apply();

      return;
    }

    if (e.keyCode === KEY_CODE.DELETE && vm.search === '' && _isMultiple && !vm.hideSearch && !isEmpty(vm.modelValue)) {
      if (vm.deleteActive) {
        vm.modelValue.pop();
        _checkEmptyAndSetDirty();
        _fireCallback('onDeselect');

        $scope.$apply();
      } else {
        vm.deleteActive = true;
      }

      return;
    }

    if (e.keyCode === KEY_CODE.ENTER || _taggingTokens.includes(e.code)) {
      e.preventDefault();
      const isEmptyList = isEmpty(list);

      if (vm.showDropdown && !isEmptyList) {
        e.stopPropagation();
      }

      if (_isTagging && (isEmptyList || vm.focus < 0)) {
        vm.selectItem(vm.search);
      } else {
        vm.selectItem(list[vm.focus]);
      }

      $scope.$apply();

      return;
    }

    if (e.keyCode !== KEY_CODE.DOWN && e.keyCode !== KEY_CODE.UP) {
      vm.deleteActive = false;
      vm.tabActive = true;

      if (!vm.showDropdown) { _showDropdown(); }

      return;
    }

    if (e.keyCode === KEY_CODE.DOWN) {
      e.preventDefault();

      if (!vm.showDropdown) {
        vm.tabActive = true;
        _showDropdown();
      } else {
        vm.focus = (vm.focus >= max) ? min : (vm.focus + 1);
      }
    }

    if (e.keyCode === KEY_CODE.UP) {
      e.preventDefault();
      vm.focus = (vm.focus <= min) ? max : (vm.focus - 1);
    }

    $scope.$digest();

    _handleItemVisibility(vm.focus, list);

  }

  /**
   * Handles the visibility of items in dropdown and changes
   * scroll position of dropdown based on focused item
   *
   * @param {Number} activeItemIdx current active item index
   * @param {Array} list options list
   * @private
   */
  function _handleItemVisibility(activeItemIdx, list) {

    if (activeItemIdx < 0 || isEmpty(list)) {
      return;
    }

    _itemHeight = _itemHeight || _dropdown.querySelector('li').clientHeight;

    const itemOffset = _itemHeight * activeItemIdx;
    const dropdownHeight = _dropdown.offsetHeight;
    const posY = itemOffset + _itemHeight - _dropdown.scrollTop;

    if (posY > dropdownHeight) {
      _dropdown.scrollTop += posY - dropdownHeight;
    } else if (posY < _itemHeight) {

      if (activeItemIdx === 0) {
        _dropdown.scrollTop = 0; // To make group header visible when going all the way up
      } else {
        _dropdown.scrollTop -= _itemHeight - posY;
      }

    }

  }

  /**
   * Checks for the outside clicks to blur the input and dropdown
   *
   * @param {Object} evt click event
   * @private
   */
  function _checkOutsideClick(evt) {

    if (evt.target.attributes['data-custom-select-item']) {
      return;
    }

    if (!$element[0].contains(evt.target)) {
      vm.deactivate();
      $scope.$apply();
    }

  }

  /**
   * Handles the paste event in case of tagging
   *
   * @private
   */
  function _pasteHandler() {

    Helper.ready(function() {

      if (_isTagging && _taggingTokens.length) {
        const separators = map(_taggingTokens, token => _taggingTokensMap[token]).join('|');
        const regex = new RegExp(separators);
        const searchTerms = filter(vm.search.split(regex), identity);

        each(searchTerms, term => {
          vm.selectItem(term);
        });

        return;
      }

      vm.selectItem(vm.search);
    });

  }

  /**
   * Unbinds the event bindings on blur of input or dropdown
   *
   * @private
   */
  function _unbind() {
    $element.off('keydown', _keyHandler);
    if (_isTagging) { $element.off('paste', _pasteHandler); }
    $document.off('mousedown', _checkOutsideClick);
  }

  /**
   * Binds the event bindings on activation of input or dropdown
   *
   * @private
   */
  function _bind() {
    $element.on('keydown', _keyHandler);
    if (_isTagging) { $element.on('paste', _pasteHandler); }
    // selected value container hides on click that is why mousedown is being used
    $document.on('mousedown', _checkOutsideClick);
  }

  /**
   * Activate the input and dropdown on focus or click on input
   */
  function activate() {

    if (vm.disabled) {
      return;
    }

    if (vm.showDropdown) {
      return;
    }

    vm.showInput = true;

    _showDropdown();

    Helper.ready(function() {
      _input.focus();
    });

    _bind();

  }

  /**
   * Activate the dropdown if input is active and dropdown is not visible
   */
  function activateDropdown() {

    if (vm.showDropdown || !vm.showInput) {
      return;
    } else {
      vm.showDropdown = true;
    }

  }

  /**
   * Focus/Highlight the currently selected item on dropdown and make it visible
   *
   * @private
   */
  function _focusSelected() {

    let optionsList = angular.copy(vm.options);
    const selectedItem = angular.copy(vm.selected);

    // Incase there is a search term applied on list
    if (vm.search.length > 0) {
      optionsList = $filter('filter')(optionsList, vm.search);
    }

    const itemIndex = _findSelectedItem(optionsList, selectedItem);

    vm.focus = itemIndex;

    _handleItemVisibility(itemIndex, optionsList);

  }

  /**
   * @param {Array} list - options list
   * @param {Object|String} item - selected item
   * @returns {Number} item index from options list to be highlighted
   * @private
   */
  function _findSelectedItem(list, item) {

    if (_isTagging) {
      return -1;
    }

    if (_isMultiple) {
      return 0;
    }

    const index = findIndex(list, item);

    return index === -1 ? 0 : index;

  }

  /**
   * Deactivate the input and dropdown on blur/tab of input or clicking outside
   */
  function deactivate() {

    if (_isTagging && vm.search.length > 0) {
      vm.selectItem(vm.search);
    }

    _input.blur();
    _matchLabel.blur();

    vm.deleteActive = false;
    vm.tabActive = true;
    vm.showInput = false;

    if (vm.resetSearchTerm) {
      vm.search = '';
    }

    _hideDropdown();

    _unbind();

  }

  /**
   * Display the dropdown list
   *
   * @private
   */
  function _showDropdown() {

    vm.showDropdown = true;

    if (vm.dropdownPosition === 'auto') {
      _setDropdownPosition();
    }

    Helper.ready(_focusSelected);

  }

  /**
   * Checks for the window viewable area and sets the dropdown position up/down
   *
   * @private
   */
  function _setDropdownPosition() {

    const elRect = $element[0].getBoundingClientRect();
    const dropdownHeight = 260;

    vm.dropdownPosUp = $window.innerHeight < (elRect.height + elRect.top + dropdownHeight);

  }

  /**
   * Hides the dropdown list
   *
   * @private
   */
  function _hideDropdown() {
    vm.showDropdown = false;
  }

  /**
   * Checks if the item is not present in the selected items list
   *
   * @param {String|Object} item item to be checked
   * @returns {Boolean} is the item not present in selected items list
   *
   */
  function isNotSelected(item) {

    const temp = omit(item, '$$hashKey');
    return !some(vm.selected, temp);

  }

  /**
   * Checks if the item is not present in the selected items list
   *
   * @param {String|Object} selected selected item from dropdown
   *
   */
  function selectItem(selected) {

    if (!selected) {
      return;
    }

    const newVal = _parseModelValue(selected);

    if (_isMultiple) {
      vm.modelValue = vm.modelValue || [];
      vm.modelValue.push(newVal);
      vm.setModelDirty();
    } else {
      vm.modelValue = newVal;
    }

    if (vm.resetSearchTerm) {
      vm.search = '';
    }

    if (!vm.stayOnSelect) {
      vm.deactivate();
    } else {
      _input.focus();
      _hideDropdown();
      $timeout(() => {
        _container.scrollTop = _container.scrollHeight;
      });
    }

    _fireCallback('onSelect', { value: selected });

  }

  /**
   * Removes the item in multi-select selected items list
   *
   * @param {Number} idx index of item in the array
   *
   */
  function removeItem(idx) {

    vm.modelValue.splice(idx, 1);
    _checkEmptyAndSetDirty();
    _fireCallback('onDeselect');

  }

  /**
   * Removes the selected item and set form dirty
   */
  function removeSelection() {
    vm.modelValue = null;
    vm.search = '';
    vm.setModelDirty();
  }

  /**
   * Checks if the item is already present in the list
   *
   * @returns {Boolean} is the item present in the list
   *
   */
  function isCustom() {

    if (!vm.custom) {
      return false;
    }

    const list = map(vm.options, 'value');

    return vm.modelValue && !list.includes(vm.modelValue);

  }

  /**
   * Take key of the label and pass it to the original object
   */
  function change() {

    const item = find(vm.options, {
      label: vm.search
    });
    const value = item ? item.value : vm.search;

    _fireCallback('onChange', { value: value });

    if (!angular.isFunction(vm.onSearch)) {
      return;
    }

    Helper.ready(function() {
      if (vm.search && vm.search.length >= vm.onSearchMinChars) {

        vm.focus = 0;
        vm.loading = true;

        vm.onSearch({ term: vm.search })
          .then(_setOptions)
          .catch(function() {
            _setOptions([]);
          });

      } else if (!vm.search) {

        _setOptions([]);

      }
    });

  }

  /**
   * Set options list
   *
   * @param {Array} options list of options
   * @private
   */
  function _setOptions(options) {

    vm.options = options;
    vm.loading = false;

  }

  /**
   * Resets the model to null in case it is an empty array and sets it to dirty state
   *
   * @private
   */
  function _checkEmptyAndSetDirty() {

    if (Array.isArray(vm.modelValue) && !vm.modelValue.length) {
      vm.modelValue = null;
    }

    vm.setModelDirty();

  }

  /**
   * @param {String} name
   * @param {Object} data
   * @private
   */
  function _fireCallback(name, data) {

    if (typeof vm[name] === 'function') {
      Helper.ready(function() {
        (vm[name])(data);
      });
    }

  }
}

export { CustomSelectController };
